import { BodySmallText } from '@prisjakt/ui/text/variants';
import { media } from '@prisjakt/ui-base';
import styled from 'styled-components';

export const Count = styled(BodySmallText)`
  display: inline-block;
  ${media.mediumUp`
        display: none;
    `}
`;
